import { IconButton } from "../ui/IconButton.js";
import { Button, Icon, useT } from "@mmm/ui";
interface MapToolbarProps {
  onAddNode: () => void;
  canAddNode: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onCenter: () => void;
  connectMode: boolean;
  onToggleConnect: () => void;
}

export function MapToolbar({ onAddNode, canAddNode, onZoomIn, onZoomOut, onCenter, connectMode, onToggleConnect }: MapToolbarProps) {
  const t = useT();
  return (
    <div className="mmm-map-toolbar">
      <div className="mmm-map-toolbar-main">
        <Button variant="primary" className="mmm-map-add-node-btn" onClick={onAddNode} disabled={!canAddNode}>
          <Icon name="add" />
          <span>{t("maps.addNode")}</span>
        </Button>
        <IconButton
          icon="connect"
          label={connectMode ? t("maps.cancelConnect") : t("maps.connectNodes")}
          active={connectMode}
          className="mmm-map-connect-btn"
          onClick={onToggleConnect}
        />
      </div>
      <div className="mmm-map-toolbar-zoom">
        <IconButton icon="zoomOut" label={t("maps.zoomOut")} onClick={onZoomOut} />
        <IconButton icon="zoomIn" label={t("maps.zoomIn")} onClick={onZoomIn} />
        <IconButton icon="center" label={t("maps.centerMap")} onClick={onCenter} />
      </div>
    </div>
  );
}
